import { OddsType, ScreenType } from "app/utils/const";
import cookie from "react-cookies";

/** A collection of session related helper functions */
export class SessionHelper {
  /** Check if the session token is valid */
  static isAuthenticated(): boolean {
    const sessionToken = SessionHelper.getToken();
    return sessionToken != null;
  }
  /** save navigation tagisd for session */
  static saveNavigationNodeIds(ids: any) {
    sessionStorage.setItem("navNodeIds", ids);
  }
  /** save latest dark mode status to loacalStorage */
  static saveDarkModeStatus(darkMode: boolean) {
    // convert boolean to string value for session storage
    let darkModeString: string = String(darkMode);
    localStorage.setItem("darkMode", darkModeString);
  }
  /** get dark mode status from localStorage */
  static getDarkModeStatus() {
    return localStorage.getItem("darkMode");
  }

  /** clear navigation node ids as session closed */
  static getNavigationNodeIds(): string | null | undefined {
    return sessionStorage.getItem("navNodeIds");
  }

  /** Check if asian view */
  static isAsianSessionView(): boolean {
    return localStorage.getItem("sessionView") === ScreenType.ASIAN;
  }

  /** Check if the session token is valid */
  static isAsianRouteAndSessionView(): boolean {
    let asianRoute = window.location.pathname.includes("/asian/");
    return (
      asianRoute && localStorage.getItem("sessionView") === ScreenType.ASIAN
    );
  }

  /** Check if the session token is valid */
  static isAsianRoute(): any {
    return window.location.pathname.includes("/asian/");
  }

  /** save setSingleCompetitionOnly to session storage */
  static setSingleCompetitionOnly(setting: any) {
    sessionStorage.setItem("singleCompetitionOnly", setting);
  }

  /** save setSingleCompetitionOnly to session storage */
  static getSingleCompetitionOnly(): boolean {
    return sessionStorage.getItem("singleCompetitionOnly") === "true";
  }

  /** store storeSingleCompetitionOnlyId to session storage for refreshing
   * SingleCompetitionOnlyId */
  static storeSingleCompetitionOnlyId(id: any) {
    sessionStorage.setItem("singleCompetitionOnlyId", id);
  }

  /** save setSingleCompetitionOnly to session storage */
  static getSingleCompetitionOnlyId(): string | null | undefined {
    return sessionStorage.getItem("singleCompetitionOnlyId");
  }

  /** store storeSingleCompetitionOnlyId to session storage for refreshing
   * SingleCompetitionOnlyId */
  static removeSingleCompetitionOnlyId() {
    sessionStorage.removeItem("singleCompetitionOnlyId");
  }

  /** get competition list time for restoring single competition only view */
  static getCompetitionListTime(): string | null | undefined {
    return sessionStorage.getItem("time");
  }

  /** set competition list time for restoring single competition only view */
  static setCompetitionListTime(time: any) {
    sessionStorage.setItem("time", time);
  }

  /** clear session storage **/
  static clearSessionStorage() {
    sessionStorage.clear();
  }

  /** get stored odds type and check if type US */
  static isUsOddsType(): boolean {
    return localStorage.getItem("oddsType") === OddsType.US;
  }

  /** set odds type */
  static setOddsType(oddsType: any) {
    localStorage.setItem("oddsType", oddsType);
  }

  /** get odds type used for public view */
  static getOddsType() {
    return localStorage.getItem("oddsType");
  }

  /**
   * Save session token in a cookie.
   * @param {string} sessionToken
   */
  static saveToken(sessionToken: string) {
    cookie.save("3et-ui-session-token", sessionToken, {
      path: "/",
    });
  }

  /**
   * Get session token from a cookie.
   */
  static getToken(): string {
    const value = cookie.load("3et-ui-session-token");
    return value && (value as string);
  }

  /**
   * Clear token
   */
  static clearToken() {
    cookie.remove("3et-ui-session-token", {
      path: "/",
    });
    localStorage.setItem("sessionView", "");
  }

  /**
   * Clear localStorage on logout
   */
  static clearLocalStorage() {
    localStorage.removeItem("sessionView");
    localStorage.removeItem("oddsType");
    localStorage.removeItem("persist:root");
  }

  /**
   * Save accept cookies terms in a cookie.
   * @param {string} sessionToken
   */
  static saveAcceptCookieTerms() {
    cookie.save("3et-ui-accept-cookies", "accepted-cookie-terms", {
      path: "/",
      expires: new Date("2129-01-01T00:00:00.663Z"),
    });
  }

  /**
   * Save delete accept cookie terms in a cookie.
   * @param {string} sessionToken
   */
  static deleteAcceptCookieTerms() {
    cookie.remove("3et-ui-accept-cookies", {
      path: "/",
    });
  }

  /**
   * Check accept cookie terms in a cookie.
   * @param {string} sessionToken
   */
  static checkAcceptCookieTerms(): string {
    const value = cookie.load("3et-ui-accept-cookies");
    return value && (value as string);
  }
}
